import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { UserService } from '@common/services/user.service';
import { marker } from '@common/translate-marker';
import { isMobile } from '@common/utils/isMobile';
import { requiredValidator } from '@common/validators/required-validator';
import { TranslateService } from '@ngx-translate/core';
import { ToastService } from '@services/toast.service';
import { throwError } from 'rxjs';
import { catchError, first } from 'rxjs/operators';

@Component({
    selector: 'app-forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ForgotPasswordComponent implements OnInit {
    userEmail: '';
    errors: any = [];
    isBusy = false;
    isMobile = isMobile();

    form = new UntypedFormGroup({
        email: new UntypedFormControl({ value: null, disabled: false }, requiredValidator())
    });

    constructor(
        private userService: UserService,
        private toastyService: ToastService,
        private router: Router,
        public translateService: TranslateService
    ) {}

    ngOnInit() {
        this.getLoadedImage();
    }

    reset() {
        this.isBusy = true;

        const userData = {
            email: this.form.controls.email.value
        };

        this.userService
            .forgotPassword(userData)
            .pipe(
                first(),
                catchError((err) => {
                    this.isBusy = false;
                    return throwError(err);
                })
            )
            .subscribe((data) => {
                this.isBusy = false;
                this.toastyService.success(this.translateService.instant(marker('Email with recovery link sent')));
                this.router.navigate(['/login']);
            });
    }

    private getLoadedImage() {
        const imageDiv = document.getElementById('imageDiv');
        const img = new Image();

        img.onload = function () {
            imageDiv.style.background = "url('../../../../assets/img/back.jpg') no-repeat center center fixed";
        };

        img.src = '../../../../assets/img/back.jpg';
    }
}
